import { Navigate } from "react-router-dom";
import { ROUTES } from "@/domain/constants/routes";
import { useAuth } from "@/application/services/authService";

/**
 * 受保護的路由組件
 * 確保只有已登入的用戶才能訪問特定頁面
 */
export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  // 檢查用戶是否已登入
  const { isAuthenticated } = useAuth();

  // 如果未登入，重定向到登入頁面
  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  // 如果已登入，顯示子組件
  return <>{children}</>;
}
